import { Paging } from '@Core';
import { BaseHttpController } from '@Core/controller/BaseHttpController';
import { PermitExempt } from '@EcamModel/model/PermitExempt';
import { AxiosInstance } from 'axios';
import { CheckDuplicatesResponse, IGetListPermitExemptProps } from '../IPermitExemptHttpController';

export class PermitExemptHttpController extends BaseHttpController<PermitExempt> {
    constructor(serviceUrl: string, client: AxiosInstance) {
        super(serviceUrl, 'permit-exempt', client);
    }

    async list(props: IGetListPermitExemptProps): Promise<Paging<PermitExempt>> {
        return await this.doPost({ path: 'filter', body: props }).then((res) => res.data);
    }

    async checkDuplicates(props: PermitExempt): Promise<CheckDuplicatesResponse> {
        return await this.doPost({ path: 'check-duplicates', body: props }).then((res) => res.data);
    }
}
